





























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DailyReport } from '@/models/dailyReport.model';
import { DailyReportStore } from '@/store/dailyReport';
import { LocationStore } from '@/store/location';

import DailyReportTableRow from './IndexPageDailyReportTableRow.vue';

@Component({
  components: {
    DailyReportTableRow,
  },
})
export default class IndexPageDailyReportTable extends Vue {

  @Prop() isTemperatureShown!: boolean;
  @Prop() value!: DailyReport[];

  @LocationStore.Bind.Getter heightUoms!: LocationStore.Getter<'heightUoms'>;
  @DailyReportStore.Bind.State isTankFieldsShown!: DailyReportStore.State<'isTankFieldsShown'>;
  @LocationStore.Bind.Getter temperatureUoms!: LocationStore.Getter<'temperatureUoms'>;
  @LocationStore.Bind.Getter volumeUoms!: LocationStore.Getter<'volumeUoms'>;


  get numTanks() {
    if (this.value) {
      return Math.max(...this.value.map(m => m.tanks.length));
    }
    return 0;
  }

  get overShorts() {
    return this.value.reduce((result, today, index) => {
      const yesterday = index > 0 ? this.value[index - 1] : null;
      const value = (yesterday && today.volume !== null && today.deliveries !== null && today.sales !== null && yesterday.volume !== null)
        ? Math.round(today.volume - today.deliveries + today.sales - yesterday.volume)
        : null;

      result[today.date] = value;
      return result;
    }, {});
  }

  get headers() {
    if (this.value && this.value.length) {
      const columns = [
        { text: 'Date' },
        { text: `${this.volumeUoms.label} Pumped`, unit: this.volumeUoms.label },
        { text: 'Deliveries', unit: this.volumeUoms.label },
        { text: `Total ${this.volumeUoms.label}`, unit: this.volumeUoms.label },
        { text: 'Over / Short' },
      ];

      const tankRange = Array.from(Array(this.numTanks).keys());
      tankRange.forEach(i => {
        columns.push({ text: 'Product', unit: this.volumeUoms.label });

        if (this.isTankFieldsShown) {
          columns.push({ text: 'Product', unit: this.heightUoms.label });
          columns.push({ text: 'Water', unit: this.heightUoms.label });

          if (this.isTemperatureShown) {
            columns.push({ text: 'Temperature', unit: this.temperatureUoms.label });
          }
        }
      });

      return columns.map(column => ({
        ...column,
        sortable: false,
      }));
    }
  }

}
